module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/octopus-star2.185019c6.png";